import React from 'react'

export default props => (
    <tr {...props} style={{ backgroundColor: props.backgroundColor, color: props.color, marginBottom: props.marginBottom }}>
		{props.children}
	</tr>
)
